import {Injectable} from '@angular/core';
import {plainToInstance} from 'class-transformer';
import {map, shareReplay} from 'rxjs/operators';
import {CostPriceComponentsQuery} from './cost-price-component.store';
import {ApiResponse, CONSTANTS, MesApiService} from 'common-shared';
import {
  CostPriceComponentPriceModel,
  CostPriceComponentPriceListModel
} from 'web-shared';
import {CostPriceComponentViewModel} from 'web-shared';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CostPriceComponentService extends MesApiService {
  constructor(private query: CostPriceComponentsQuery) {
    super('CostPriceComponent');
  }

  getAll$ = this.query.selectAll();
  getAllComponents$ = this.query.selectAll().pipe(map(values => values.filter(value => value.TypeClv === CONSTANTS.CostPriceComponentType.ClassificatorId)), shareReplay(1));

  loadOne(id: string) {
    return this.getSingle<CostPriceComponentViewModel>({id})
      .pipe(map(value => plainToInstance(CostPriceComponentViewModel, value.data)));
  }

  getAllItemCostPriceComponentPrices() {
    return this.getAllCostPriceComponentPrices('GetAllItemCostPriceComponentPrices');
  }

  getAllResourceCostPriceComponentPrices() {
    return this.getAllCostPriceComponentPrices('GetAllResourceCostPriceComponentPrices');
  }

  getAllCostPriceComponentPrices(action: 'GetAllItemCostPriceComponentPrices' | 'GetAllResourceCostPriceComponentPrices') {
    return this.getList<CostPriceComponentPriceListModel[]>({action: action})
      .pipe(map(value => {
        return plainToInstance(CostPriceComponentPriceListModel, value.data);
      }));
  }

  addNew(cpc: CostPriceComponentViewModel) {
    return this.add<CostPriceComponentViewModel>(cpc)
      .pipe(map(value => plainToInstance(CostPriceComponentViewModel, value.data)));
  }

  save(cpc: CostPriceComponentViewModel) {
    return this.update<CostPriceComponentViewModel>(cpc.Id, cpc)
      .pipe(map(value => plainToInstance(CostPriceComponentViewModel, value.data)));
  }

  remove(cpc: CostPriceComponentViewModel) {
    return this.delete<CostPriceComponentPriceModel>(cpc.Id)
      .pipe(map(value => plainToInstance(CostPriceComponentViewModel, value.data)));
  }

  exportExcel(ids: string[], action: 'ExportItemCostComponentsAsExcel' | 'ExportResourceCostComponentsAsExcel'): Observable<{ fileName: string, data: Blob }> {
    return this.http.post(this.getRoute({action: action}), {items: ids}, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(map(value => {
      return this.getFileNameAndData(value);
    }));
  }

  importExcel(fileData: string, action: 'ImportItemCostComponentsFromExcel' | 'ImportResourceCostComponentsFromExcel'): Observable<ApiResponse<string>> {
    return this.addGet<{ Model: string, FileData: string }, ApiResponse<string>>(
        {Model: null, FileData: fileData},
        {action: action}
    ).pipe(map(value => {
      return new ApiResponse<any>(value);
    }));
  }
}
